export class ResetPasswordModel {
    phoneNumber: string;
    code: string;
    password: string;
}